import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NcProcessingDialogComponent} from 'nc-processing-dialog';
import {DialogConfigurationUtils, DialogService, DialogType, FormUtils} from 'nc-utils';
import {NcInformationDialogComponent} from 'nc-information-dialog';

@Component({
  selector: 'nc-submit-button',
  templateUrl: './nc-submit-button.component.html',
  styleUrls: ['./nc-submit-button.component.scss']
})
export class NcSubmitButtonComponent {
  @Input() disabled: boolean;
  @Input() buttonLabel: string;
  @Input() dialogLabel: string;
  @Input() id: string;
  @Input() formGroup: FormGroup;
  @Output() buttonClick: EventEmitter<void> = new EventEmitter<void>();
  isProcessing: boolean;
  contentInput = NcInformationDialogComponent;
  configuration = DialogConfigurationUtils.info('checkAllData', 'info');

  constructor(private dialogService: DialogService) {
    this.isProcessing = false;
  }

  clickHandler = (): void => {

    if (!this.formGroup || this.formGroup.valid || this.formGroup.disabled) {
      const dialogConfig = {disableClose: true, data: {label: this.dialogLabel}, id: DialogType.PROCESSING};
      this.isProcessing = true;
      this.dialogService.open(NcProcessingDialogComponent, dialogConfig);
      this.buttonClick.emit();
      this.isProcessing = false;

    } else if (this.formGroup) {
      this.dialogService.open(this.contentInput, this.configuration);
      FormUtils.validateAllFormFields(this.formGroup);
    }
  }
}
